import React, {useState} from "react";
import {Button, Card, Col, Row,} from "react-bootstrap";
import {useMutation, useQuery} from "@apollo/client";
import {Link, useNavigate, useParams} from "react-router-dom";
import moment from "moment-timezone";
import PATH from "../../../routes/RoutePath";
import QUERY from "../../../utils/service/query";
import ProfileBanner from "../../../components/profile/Banner";
import ActivityLog from "../../../components/profile/ActivityLog";
import Flex from "../../../components/common/Flex";
import {toast} from "react-toastify";

const UserReportDetail: React.FC = () => {
    const {reportId} = useParams();
    const navigate = useNavigate();
    const [page, setPage] = useState(1);

    const getReportedData = useQuery(QUERY.REPORTS.GET_USER_REPORT, {
        variables: {reportId: reportId},
    });
    const {getUserReportDetails} = getReportedData?.data ?? {}
    const {reportee,reporter} = getUserReportDetails ?? {}

    const res = useQuery(QUERY.USERS.GET_ACTIVITY_LOG, {
        variables: {userId: reportee?.uid, page: page},
    });

    const [updateReport] = useMutation(QUERY.REPORTS.REPORT_USER_STATUS_ACTION);

    const handleGoBack = () =>{
        navigate(-1)
    }

    const updateUserReport = (status: string) =>{
        updateReport({
            refetchQueries: [
                {
                    fetchPolicy: "no-cache",
                    query: QUERY.REPORTS.GET_USER_REPORT,
                    variables: { reportId: reportId },
                },
                {
                    fetchPolicy: "no-cache",
                    query: QUERY.USERS.GET_ACTIVITY_LOG,
                    variables: {userId: reportee?.uid, page: page},
                },
            ],
            variables: {
                status: status,
                reportId: reportId,
            },
        })
            .then(() => {
                toast.success("Report Status updated successfully");
            })
            .catch(() => {
                toast.error("Something went wrong!");
            });
    }

    const handleMarkAsCorrect = () =>{
        updateUserReport('Correct')
    }

    const handleMarkAsInCorrect = () =>{
        updateUserReport('Incorrect')
    }

    return (
        <>
            <Card className="mb-3">
                <Card.Header style={{display: "flex", justifyContent: "space-between"}}>
                    <h5>Report ID : {getUserReportDetails?.reportId || "N/A"}</h5>
                    <Flex justifyContent={"end"} style={{gridGap:15}}>
                        <Button className="" size="sm" onClick={handleGoBack}>
                            Back To List
                        </Button>
                        <Button className="" size="sm" onClick={handleMarkAsCorrect} disabled={getUserReportDetails?.status === "Correct"}>
                            Mark as Correct
                        </Button>
                        <Button className="" size="sm"  onClick={handleMarkAsInCorrect} disabled={getUserReportDetails?.status === "Incorrect"}>
                            Mark as Incorrect
                        </Button>
                    </Flex>

                </Card.Header>
                <Card.Body className="bg-light">

                    <ProfileBanner
                        profileImage={reportee?.profileImage}
                        fullName={
                            (reportee?.userProfile?.firstName ?? "") +
                            " " +
                            (reportee?.userProfile?.lastName ?? "")
                        }
                        userName={reportee?.displayName ?? ""}
                        userType={reportee?.userType ?? ""}
                        email={reportee?.email ?? ""}
                        phone={reportee?.userProfile?.phoneNumber ?? ""}
                    />
                </Card.Body>
            </Card>
            <Card className="mb-3">
                <Card.Header>
                    <h5>Report Details</h5>
                </Card.Header>
                <Card.Body>
                    <Row>
                        <Col lg={3} className="mb-3">
                            <Card.Text className="m-0">
                                <b>Reported Date</b>
                            </Card.Text>
                            <Card.Text className="m-0">
                                {moment(getUserReportDetails?.createdOn)
                                    .tz("Australia/Brisbane")
                                    .format("DD-MM-YYYY") || "N/A"}
                            </Card.Text>
                        </Col>
                        <Col lg={3} className="mb-3">
                            <Card.Text className="m-0">
                                <b>Reported Time</b>
                            </Card.Text>
                            <Card.Text className="m-0">
                                {moment(getUserReportDetails?.createdOn)
                                    .tz("Australia/Brisbane")
                                    .format("h:mm A") || "N/A"}
                            </Card.Text>
                        </Col>
                        <Col lg={3} className="mb-3">
                            <Card.Text className="m-0">
                                <b>Reporter</b>
                            </Card.Text>
                            <Card.Text className="m-0">
                                {reporter?.uid ? (
                                    <Link
                                        to={
                                            PATH.USERS.USER_PROFILE +
                                            reporter?.uid
                                        }>
                                        @{reporter?.displayName}
                                    </Link>
                                ) : (
                                    "N/A"
                                )}
                            </Card.Text>
                        </Col>
                        <Col lg={3} className="mb-3">
                            <Card.Text className="m-0">
                                <b>Reportee</b>
                            </Card.Text>
                            <Card.Text className="m-0">
                                {reportee?.uid ? (
                                    <Link
                                        to={
                                            PATH.USERS.USER_PROFILE +
                                            reportee?.uid
                                        }>
                                        @{reportee?.displayName || ""}
                                    </Link>
                                ) : (
                                    "N/A"
                                )}
                            </Card.Text>
                        </Col>
                        <Col lg={12} className="mb-3">
                            <Card.Text className="m-0">
                                <b>Reason</b>
                            </Card.Text>
                            <Card.Text className="m-0">
                                {getUserReportDetails?.reason ||
                                getUserReportDetails?.otherText ||
                                ""}
                            </Card.Text>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>


            <ActivityLog
                activities={res?.data?.activityLogsList?.list || []}
                totalCount={res?.data?.activityLogsList?.totalCount || 1}
                currentPage={res?.data?.activityLogsList?.page || 1}
                pageSize={res?.data?.activityLogsList?.limit || 25}
                setPage={setPage}
            />
        </>
    );
};

export default UserReportDetail;
